module.exports = {
  // 付款方式
  TYPE_ATM: 'atm', // ATM
  TYPE_WEB_ATM: 'web_atm', // Web ATM
  TYPE_CREDIT: 'credit', // 信用卡
  TYPE_CVS_CODE: 'cvs_code', // 超商代碼
  TYPE_CVS_BARCODE: 'cvs_barcode', // 超商條碼
  TYPE_CASH_ON_DELIVERY: 'cash_on_delivery', // 貨到付款
}
